import { createFromReadableStream } from "react-server-dom-webpack"
import prefetchHelper from "./prefetch"
import emitter from "./emitter"
import { setMatchPaths, findPath, findMatchPath } from "./find-path"

/**
 * Available resource loading statuses
 */
export const PageResourceStatus = {
  /**
   * At least one of critical resources failed to load
   */
  Error: `error`,
  /**
   * Resources loaded successfully
   */
  Success: `success`,
}

const preferDefault = m => (m && m.default) || m

const stripSurroundingSlashes = s => {
  s = s[0] === `/` ? s.slice(1) : s
  s = s.endsWith(`/`) ? s.slice(0, -1) : s
  return s
}

const createPageDataUrl = rawPath => {
  const [path, maybeSearch] = rawPath.split(`?`)
  const fixedPath = path === `/` ? `index` : stripSurroundingSlashes(path)
  return `${__PATH_PREFIX__}/page-data/${fixedPath}/page-data.json?v=c90b2e71d9d096005f34e6041e7196e7?v=de6a293eda370d417032715ded7e7956?v=bcce847ce652f364337f50a1eb69ac49?v=378a01795a6b3b2ed16e822c048d75d2?v=ebe8f49de735ec197a62727e7296b305?v=a4f6c22590de7c02157a9c10adf02ae1?v=86e70993d9773a1547df6bfb9426a5ac?v=c1be511886285dcad8b5da0b54df7535?v=f4522cb7266b34717d7b5fb5deb79cbe?v=0a9c8b7eb3dec87a8d4cf7181e91f0d0?v=0de23f187831a6ac98853ff5c9819186?v=cf70d69321716b90a99e1e48c7234536?v=b27930562989526484d6e1ecc5ce4765?v=e5d026e369ba4c00f08ab640fd8cf02f?v=ae39cdf4220e70300dbd4012abed4a46?v=6f50ce3ea78c46fcee05a17c267c6a80?v=816b3898128a08f1533cc47099b17ee9?v=ba801cb1f8ff6e0e9780b75636c1d4aa?v=27c2ab8c77869bad67d3cc4d5a59aa1b?v=d088421b75c2a7da2ff6390e0d8f2b01?v=c335d0b1a14c5036516b691bf87c12cb?v=3bdd0a90ee947acf0ce36fce5e727a26?v=20f90eaa604b643287cbc1c69343a9a9?v=c258deab0b33d2adc93eb0e5745e05bc?v=190cc153cffb783218347700592c4a24?v=3a51465551267c128ac46558defb63b9?v=91c71b13753fdd4781a88c99af704539?v=a976b400f06d1490796e33582c26d37d?v=36364f798053327ced7703dfc977bb59?v=29244dc19e5516e6301bb69b56d2367d?v=d61bed73d0852426b98f0d86e0fa8ce3?v=52ec70a7d770eeb65aa40b543680d0b1?v=c0d9443aa698f010d6868e00140062f1?v=ce87f8a8743c430cfb48ed955be12730?v=75db1de3515da78b19c71c16e4441043?v=cd39989b6fa565d6a35aa5de0bc84f4f?v=4d71d5ca1f13725e588822be98a77d2b?v=bb1cd410378f9369cc230c06c6f8d460?v=f64ed631f122320b12dcf5dfc4ebaf4b?v=e19a6e291abe521dca0a6f3d86e77796?v=8dcbe72760f44c88052b63fc59f328cc?v=938c3555b8fbd4997cf8457a0a349258?v=95a53cb42c3935d296355522b3ec9da2?v=3ce056e2df655f8c7c1c64317dee8465?v=f8153cf52a2069824d37eb2b1d72dfb4?v=a045919ec07b1851c0b77c35a807f39e?v=6ff544ee36450a2925e54b53f6e68f51?v=3ce264d93e7669d1899a60c9fbb54b04?v=4ae42ae2f06a298cb6077d510b5641ae?v=a9ba9c8d3c964d88f6d91f9b59ca9417?v=469eb2f0c3fe607ff915b8442dd0a25c?v=f5d648c1e56f25388ea9e1dd1a214346?v=3762861151995d7d2f081ddca1ffbfe9?v=99c51a32081a85dbba8ffabbc486bf3d?v=deb19b962fb539878827b94799469be5?v=92c72ff9f03bbb5dc534f638507f8911?v=db8790fb8ce4897246f53c700b3e410d?v=fb5ad78a6d327ee6faf0d38a207a2847?v=060c57ddda5066007a5b45e0d49b6856?v=1c451aa00ed885b2c9f2ab06b9777cab?v=0394ea4a64763ec258af348073462867?v=9e225bdcb12be8037a6bf051175d1a0e?v=028b561ff2651df47a3911c57b8c1596?v=66db2c0ac01085f3fefbf16d3df0e032?v=8b1fafed7e215d97b897031f2d6564dd?v=28594467ccc28fb185668be18c78f27a?v=7fc15f486d31f5beca0997dc2bff81c6?v=30de21c60b00424bb30ad45d734086cf?v=511e144bc1faefaba256e074e3ea7b55?v=a7077303b269a6f1b4b518c4cb0059f6?v=4b6a516344c0b7709c5c0e6b299e426e?v=bb18d53401ddd66888c9c9576c1d2276?v=be76b019bfb38cc8fb0314ba1bc4d82b?v=b6dbdba0b1ff3e5be5568cebc3c7e79a?v=ad13de39b93d7d9431d7b26e5127eb8a?v=80411cd7490a13a89483f057db6f4dee?v=8d025c266b331e6503aae1fbfd671139?v=e4647a0510ad7029c83aadc6f8d35988?v=a5a32a39c7b1645710e349712e1bc08d?v=5d35f043d07e1f079405b7ccb371ecc4?v=b1fbae0f57b2e33fd6b4cf51add8c168?v=aa790c17b3b477e89d1a53a4d2987500?v=14f7cbeb42ab302fe9f92ee9fc67cf8a?v=dba6caf4ef5673cc17c89c3a1743cbf0?v=0e3c3edf50dc94656fe96ae38e186014?v=2a9497513ff0d8f455a0007cab8ab140?v=c016949130ed532b9151c4aaef80f10c?v=a557f50d1240015f6bf333bbb1ffa903?v=32021e85a7282a384210bd83090cc4fd?v=f188f4a283a06757a63e75e9d0494011?v=9aa467067d9eca648f2f356e7d24620c?v=128ee5aec56689f7efa2e91a250399ab?v=2ec7893611047491b200fd0fbb88bfc2?v=d39f8b6b4f6790c284ad02cf7a4d7303?v=ae7ea6d623e77a980b30265f478fc10e?v=2dace27fe17e8361d91baf047cbe6426?v=ad0945a737bf0b1b0dbfaf9d037796a6?v=8def7bacf9225aed1c13580cd78f8f15?v=96c42d40ec031a81ddd1b8cff11a5766?v=02dc70366713f4e24f6732549ca1e568?v=c2d77ce9da6ef111a36a8fb2a0473cc0?v=af173121666c20a8977947f9a8249f41?v=a785736082243afda0f558be1e086817?v=7c93c64a012f1e113ba3a24e68f187ff?v=767aea8b1ae7b73b7d03288eaae31f99?v=a2bf8b29faddd0a8a39a1b5da70a8e9d?v=77758521f30d72b5b9346041c10ab42b?v=335f60c630553176bc6817fc1034e991?v=94cc6168f76bd97701cda3225f5f53ba?v=269e7d5f425d01759f81cd42ed017645?v=0cc915aa724f07d18c09bbed5df51630?v=737b66d5f93b368b3137241144cbaa94?v=0e309d7f3057d8d554da500af49a2f89?v=823b5b2b74f6ca2f8fa0e6f76bef86d5?v=4577fc403b1126cffced97e9a6e5f2a6?v=6b44ed20d82fef919dba57b122d8bf8f?v=d46285295fa17d5cc6812d487e1bff44?v=7b58a1a609509d287a89cf3aadbd9a93?v=82b2d5a3e990f836143150fedf44f668?v=1134f67d16164a1c6b1acfe9a26f16eb?v=5a0412ec88f145b165e67fca9199d211?v=b2a3a27c3fd91b6a87ef23f84f445545?v=8d344b3981cf89f49c79f26911eba927?v=92a5f54f5f723e50ff5c13aa6fa41f30?v=f83650c63a7a0a15f1ee334e96641410?v=7330e58fa5f4e694575d22e2df0d64e6?v=edacf3a630d65123c08db57e6caad262?v=21a1a6d6ba39076f7a9fd3f1b7d6fdf3?v=00215fbdd9141ad1cefd7e688dcaaec5?v=361dd83eeb7552fc63522fe61f4761f4?v=a40defa880adef4b84170fa9a2525f2b?v=4fc699fa9f4f8fb637b03cf7d8d4e0b5?v=6969fee8d1075d72ebe2cef852ebe30c?v=782d525ebf69f3c0f362be8a0cbc70c3?v=d48f15929c06364e875a2b3312260556?v=cfa2d06163a08977a31c8404c59884bd?v=d3948eaf76e40ef169123c53795fb38b?v=091e2296eaed75f12d2377f257e9fbd5?v=a05d1cc21ae020cadfbc6c532954aee4?v=c115b1e87ee4d7dd4f700549ca4fd183?v=cf7c3377bf5590ab19702fe60aae99eb?v=c95a8fd8539ec3acc7b74e4a38f22430?v=fa64887e0495d0785ba9f9016fd3bbc5?v=49544bc2f764fc6e4bffb7598eef3d44?v=3765846d875a6f854638944aa9ec9251?v=02b8e369764a5502e5cf1591dcd15b9e?v=f06cc6c621ebc24dd55df877b43e479e?v=b3e6942155b8c3c46345e708ce1b4bdb?v=e5211373f75743a6e6775a6820b3d2cf?v=d3be8099ccd8ca0b4f0a4f8de0d4693d?v=b664b626c8367dc423fd674844bf1c54?v=61a0853889d081d088e80120b7755ea3?v=0f690695fabc2488efe36e264ff329ce?v=2d71909a4d9d31bca78cd53f533c83af?v=8eebd634bab7f8bfe4d8f90ccc23f221?v=071e2aa8dbd6189c3cf7ca7b0a215081?v=ce6e289f0569c9884f940db2ccb7bc01?v=34649b6f2eea22866a31c524284f299e?v=df89c2a41a42d1eddd29738e1e24d401?v=776375e349971ddcf0c9a147fff485fb?v=5cb5dd2eaac4b7847616e7a35e46e6e2?v=103e611206fe0b18eab31c2f335602b1?v=f7367dd6158af41ec15a22e0e493b0d8?v=60c84a015f5e6b4c6dc37676284c8454?v=2774dac1deb6e96a1819d8217e1d560d?v=f9571963ed2f841a27684f6209cf2a2a?v=7f07b2db63b0323d92c0986aa5f0fb10?v=65d96c40555d79767e2ab6a7576f0453?v=d8a6dd16869dd790a5bc3063f5b95c8a?v=1b7a03bc575425193144d5029037dfc7?v=db702a05359a8a7cdfbada5b58178a88?v=0ec2ff25bd749576428c075f9acc92c5?v=6b8a1f9624a6e84a6bea3ea74d9c9ad6?v=aaa3415c8b62a089ede98d9d4a5d898a?v=0b11b2ddeadf4b7174d53c3339bbf6b9?v=0cc4c438aad30fec1ea4628894aa3973?v=843afa184d074dbc1ebfcee682ae3681?v=5d7977ee7860b9f654d5d04984945c73?v=6a24cf6d719a8a1e9e22bda4b25a4bc8?v=dd91f4287fa09e83fc44070deb3850a4?v=0f49b6ec1d7d19bc52bbf96cfeb251fd?v=6ee53c1f107db9beb17ffb19a48d6e1e?v=9873efb1756eafb9a829c9890e68472a?v=98d3f875f222494073e8a31a5ab7a0a7?v=d33addcc8a4d6c547b0d331092a714b1?v=a6d4da4ce7dd33ee292bf670974a52a7?v=f74e82d67e0b29af7412b4c0b02c8b2c?v=579b8b566a4f3bbccb670ee6db6f8d11?v=871473a43b50da777ec5c60fe659df80?v=d53206bd1062345c08e3ceff4a0af8aa?v=0a4f4ab36e6c2c2f242aebd13baecfe0?v=606ab8994f56bc1abacbc07daa0b56c9?v=db72e1e3028851f20363f9836ad34e75?v=55c9d73a19734764a3991f042fabb67c?v=886c02f9280e7a0b812a293a89cf17dc?v=768b46e97a8b2a442f3df788a7bd496a?v=325ebcd0dc6b727d987bd1438b51a401?v=ecb86efca79ca7d438cd2495d9bb7b46?v=63356d817f4997a35666933d5cf54824?v=65eb239adb39de87d79361d6c94e93f2?v=43d6967d7724706ffae28d24ee7d7dd9?v=0ebc869db1ede616d55fca392dd5a5cf?v=9f297a35bff57559af2c7ad4ca5640c3?v=5f9488d2769808ad91b26ee35a8b593f?v=374ced41a5eb872040503053c8d895a6?v=c894e1fd3d89b8ee677119e3d9827ce4?v=a74378f67b8f12667cc1de0b229ce7f9?v=13ac8dc4faed29e9b6211ba6b02efa37?v=074f6bf71ae1725bf0297f9cc789c96d?v=0ab6b636db59bc255546bd679bb6e383?v=2c91f7087812dbe5f4cbe6978a0428c0?v=addc484352b01f3a0dd3686ab965ffd9?v=718fa05234425a287fdae4956cab7f87?v=22ddc2d4dd5cbcf7b8019bd29694ad2d?v=2f94bca39e06fc8ea4d5313934545038?v=72147d932127caa22ad764f1a6ac6864?v=d5b80d66599f1bd97ac1e34236cc8a6d?v=6dda51152b014fa43373cc3c96a68b05?v=7ab1b158cc0f65fb6f7c7d2d2a80174e?v=36704ed53a8ed226a3cd4083c893d687?v=602ddffe906dd55fe6d9721016f6c6a0?v=6a7cf00259d32fd56055ed13f51879e9?v=93e81c4d7d5d795b15ce8f675339a64e?v=ecf8e74a0974f31cd49d7e44473bffa8?v=17fdc9ade8ac49544115b9e2802c8547?v=f5b78f0edfa8b5e02bb026ac4d530014?v=cc3044accc8e8a3a23adc0da51f34c03?v=263aedd21b868c88721f60b7472f1a17?v=9b04c59a30ae145d3ecba8e0179143fb?v=4d3df79e1541328c899723de2947ebf3?v=42afb26efc0b226b4ce735bebe169170?v=a4b31f5f72ed4f7ed4d965b446681aaf?v=f52a8debb11f619574d7a1d2b19b34c4?v=48be6d10ccb2f05ae1592af9a458e266?v=1db3817f20843745b49373f673859ad0?v=a8583d9d14dddf312e8542710a5faf6b?v=5d8cd3a3578ef6073f1970d7ec3e8c20?v=fbb1298e72b4c213b1a89404332f77d4?v=833fc5872589038f467192a1f18932fb?v=abef2cafcffb91e463dab34637ab6c84?v=5954886c4230ff9c53348a079e8c7fdd?v=f5cce6093376d77fc3b678449d56124c?v=aaf6c4bdf7c57b522753a87c7c70b434?v=966f84dddc2905a64fbc62a3c3a2c7f4?v=dba5c241b691585c0109b8d35a4511f7?v=4817d0c711fb5be1c9f8bfb8fa39c6e0?v=cf8ab6c2e8019d66e0f8b6ba42917311?v=d6a994f5b5d83f68c2af08a606921acd?v=02db719cc19831a482bb2f743c1516a5?v=2e7a6e07373dc812cf3f2f2b31e76cef?v=82d608c3718d4985c3ea755768669cde?v=01bcb01924bddb23b60e71c8265e1c5f?v=4ec6011502abc9ce613fbb3d975ea02c?v=0cfc2a4dd4a770001aee00e4a2080e86?v=a7e2225a1fcee96007b1b5d183789386?v=39e83df4193b2026c9e26c95c2a407f8?v=62be8ff039c7f8c8e55ac7698831a2b3?v=c37451b9611558f27cd5f4b35bde767d?v=70ba6f56383d4f9f76c17b430c2910c6?v=66b796b22583789a1a3851559ff0dac1?v=f8abd3f67806a3b7fdac27b1ad5fc7b3?v=8b13617eaa6820ad13fab5ccc7b2bba2?v=cbd6492633cc435ced115e3981719ebe?v=0c8da82f0cfa13979d9d685615c945a6?v=1e20402ee367d808f7c28346af8ef1a7?v=729a912eb4242590adab36b5ef973d5c?v=3bee87fdf322d5de491461b367bcc1d7?v=a0099aa4d97fbddbfab650d6882da999?v=0fe2e72ca9703bd01c0d4c3b671cdb29?v=d75680f0d4437319b105bec72b8ae237?v=b63068a51d370e9bc1ae3acd9f2dd6c8?v=35348663c5ad0d6c0604e205c79a38e1?v=ea2f368b116d6521b8573b89a8ff3864?v=c57d79b3c6ebfbd29900f41fd19950cc?v=711869299ad41e4a1949ab2976ba6772?v=22e774eb8d5b91553100f66ad47a2ae7?v=319184542e7cd02fc22fc2c843dcb5e1?v=87b40896490ca08ed9950540aeb58c5c?v=d72b71188789b7689db0d816810a214c?v=3c815e060e66138e8bc236a9d385d340?v=577d3b072e677af665bfbe14a7ee5b50?v=07ab93a4c752e2febbf6b649fb931604?v=026aad87946e9212af0272a0fb1eadbc?v=490301f40eda0e951255737b67c9db78?v=d5702f9cca2658114d81e5cee30a5086?v=65e9a8c3a318a3e8a701dba5e1a27ba0?v=d2465a94686a021f59bb00affdd6caec?v=eb4929b54238df0bcd7097bb53ecea58?v=0b8ae50ee778a631ad70dbaf824679fe?v=12450336b66fbffd24a207b386d91020?v=6797283d5157a44063ccf8dc318c4c2b?v=f69a74e5a714eec078dc719ca4c2c4b6?v=0237a6167af0936818d0d53b4839f333?v=f37de54aab9b1541de8193bed1ab8c78?v=f4a80f7b491f733c145dbbfd2e93ba53?v=e5f0d436cc541f0753d947492b5760ec?v=abbabe38e4e3fc74d6ad2d52c8f66e4d?v=dad4d8c9416a4338435b0b703de8f4d9?v=5b1f3b602a0c86354225413d8763d851?v=4e9437b9242d011264f3f1ebb5142d69?v=ab6480b521105dccdfa147266093391a?v=5455e8dedcfc9f8dd4dd551b8170a4f0?v=38cb81921d182dc1d6f442d1f8222d05?v=86ff8343d866152fe438ba15e397fa34?v=908c10bd139cdb6b77d9eca2b1d1e41a?v=4603d8d366d3755f3c6fc9f1fe82943d?v=bf18fc199e4d9322c0ced11b2c278256?v=6ea609a05a1cd6c48b8dd87496a51c74?v=d8119f19ec25634c8a483ac04e33e263?v=68eaea33abace91f7310ead9b982b13a?v=e1240964528291e378fcdc020e6cc2da?v=34b26d7d2a8dba8eec6fec968e75f184?v=746ec28ca1a5dd0b5ed62bcb384ee489?v=24985f5fafac569e8a235328d3f47990?v=0d63037acf31954d274b4fb527c2b97c?v=f9c05d5d45b8842fc89b73be625aaa5c?v=3a74f73e436eee54d03b28dea9154142?v=4745ce14c97fed05388d3c6a5f49b2b9?v=73731732788c6236bd568666a076e1c4?v=915c75b79c0ab5b6439a17fe31848729?v=aa5a65befffd30bc52afe3dc20ca0a55?v=c900305e8b39b9c7dd638a9b2bd5c16d?v=e0bd750d7d82b7f54e770d9f3e7781b4?v=16850b7022c8fb8446222ab80f6884d1?v=23f76471f53743835e5cc3994892b22a?v=2c15a4c39146e4b82443e65f3bd1aa81?v=88473375be3af8f33f68d8202053b1d7?v=ca60d47e01249efd16dfc9a02814025d?v=6e7f12e70722e1ad609b315be8195d4c?v=f2d97e48a02c25390c9436f95ac4e0ac?v=8c819a4c32fc7c41832a987dd8c865a8?v=0f876e8115aed2457a0f02a13178d922?v=9fc906a43a0222b66e6501d0dd9bd609?v=9c834812c1403cbe4bb8018f24fb6657?v=6072859bddb134dfc66a3311d65b9089?v=731dc5d0d41723a9034e01c7d09c1293?v=ccdc22a935947901461ce591e44fe58f?v=bb0b50829700830051850f374cdbfceb?v=888589f32fe6e2f7592f408eb0eea0f2?v=81f489a295c03216d558ca1d14934664?v=316f90112324b69e4e9beb9d68645f2e?v=ec2c92f226882e0aa5714ecb46408508?v=9c8fdaef30f76df214d590a088e1e69a?v=7aba6cbda365f53612e049b0250a34df?v=c61881eb6079fb901277c6de93ff4d97?v=fd3c26243a61ed207364fcf7af08e39a?v=25a9183ac6db41361faa106fd686510f?v=07a8da3fff44a37eda9c80059ca2f2f2?v=c19f5124ff1c8e8a805d33c27150c8db?v=48715cc1ac966103d72f5cd9e23f3e15?v=d99237f76436dec9798014f74fd9392e?v=7faf0e5cdb7d7b2e6f45efc4396d63bb?v=95fef3f244fb879ec43f4472c67cbc1e?v=d85ac9f67292d57a2c20a266f5e34336?v=df867b7f010bf9b42bfcbb73aec5c94f?v=4b860ccd3614510e759a4e408dfed322?v=59ce2178ded94648b551c9e16ebf6a7f?v=65ed644f68db7049ff6fdce8d45db258?v=f3b076f34f6d3ec97a0d52f37c6e874d?v=9d8515f8e7a3760095153d5d425490a6?v=464aba06196872409680a1b5ca38968f?v=d6e8d301e4a62003b6127e4a63bc3697?v=d1141f0112f079e2754ff3bd77f72c97?v=4725320484cc277bd521a99a52be9f55?v=1f45f43e3ef9db2ee1b61b8706d6d32e${
    maybeSearch ? `?${maybeSearch}` : ``
  }`
}

/**
 * Utility to check the path that goes into doFetch for e.g. potential malicious intentions.
 * It checks for "//" because with this you could do a fetch request to a different domain.
 */
const shouldAbortFetch = rawPath => rawPath.startsWith(`//`)

function doFetch(url, method = `GET`) {
  return new Promise(resolve => {
    const req = new XMLHttpRequest()
    req.open(method, url, true)
    req.onreadystatechange = () => {
      if (req.readyState == 4) {
        resolve(req)
      }
    }
    req.send(null)
  })
}

const doesConnectionSupportPrefetch = () => {
  if (
    `connection` in navigator &&
    typeof navigator.connection !== `undefined`
  ) {
    if ((navigator.connection.effectiveType || ``).includes(`2g`)) {
      return false
    }
    if (navigator.connection.saveData) {
      return false
    }
  }
  return true
}

// Regex that matches common search crawlers
const BOT_REGEX = /bot|crawler|spider|crawling/i

const toPageResources = (pageData, component = null, head) => {
  const page = {
    componentChunkName: pageData.componentChunkName,
    path: pageData.path,
    webpackCompilationHash: pageData.webpackCompilationHash,
    matchPath: pageData.matchPath,
    staticQueryHashes: pageData.staticQueryHashes,
    getServerDataError: pageData.getServerDataError,
    slicesMap: pageData.slicesMap ?? {},
  }

  return {
    component,
    head,
    json: pageData.result,
    page,
  }
}

function waitForResponse(response) {
  return new Promise(resolve => {
    try {
      const result = response.readRoot()
      resolve(result)
    } catch (err) {
      if (
        Object.hasOwnProperty.call(err, `_response`) &&
        Object.hasOwnProperty.call(err, `_status`)
      ) {
        setTimeout(() => {
          waitForResponse(response).then(resolve)
        }, 200)
      } else {
        throw err
      }
    }
  })
}

export class BaseLoader {
  constructor(loadComponent, matchPaths) {
    // Map of pagePath -> Page. Where Page is an object with: {
    //   status: PageResourceStatus.Success || PageResourceStatus.Error,
    //   payload: PageResources, // undefined if PageResourceStatus.Error
    // }
    // PageResources is {
    //   component,
    //   json: pageData.result,
    //   page: {
    //     componentChunkName,
    //     path,
    //     webpackCompilationHash,
    //     staticQueryHashes
    //   },
    //   staticQueryResults
    // }
    this.pageDb = new Map()
    this.inFlightDb = new Map()
    this.staticQueryDb = {}
    this.pageDataDb = new Map()
    this.partialHydrationDb = new Map()
    this.slicesDataDb = new Map()
    this.sliceInflightDb = new Map()
    this.slicesDb = new Map()
    this.isPrefetchQueueRunning = false
    this.prefetchQueued = []
    this.prefetchTriggered = new Set()
    this.prefetchCompleted = new Set()
    this.loadComponent = loadComponent
    setMatchPaths(matchPaths)
  }

  inFlightNetworkRequests = new Map()

  memoizedGet(url) {
    let inFlightPromise = this.inFlightNetworkRequests.get(url)

    if (!inFlightPromise) {
      inFlightPromise = doFetch(url, `GET`)
      this.inFlightNetworkRequests.set(url, inFlightPromise)
    }

    // Prefer duplication with then + catch over .finally to prevent problems in ie11 + firefox
    return inFlightPromise
      .then(response => {
        this.inFlightNetworkRequests.delete(url)
        return response
      })
      .catch(err => {
        this.inFlightNetworkRequests.delete(url)
        throw err
      })
  }

  setApiRunner(apiRunner) {
    this.apiRunner = apiRunner
    this.prefetchDisabled = apiRunner(`disableCorePrefetching`).some(a => a)
  }

  fetchPageDataJson(loadObj) {
    const { pagePath, retries = 0 } = loadObj
    const url = createPageDataUrl(pagePath)
    return this.memoizedGet(url).then(req => {
      const { status, responseText } = req

      // Handle 200
      if (status === 200) {
        try {
          const jsonPayload = JSON.parse(responseText)
          if (jsonPayload.path === undefined) {
            throw new Error(`not a valid pageData response`)
          }

          const maybeSearch = pagePath.split(`?`)[1]
          if (maybeSearch && !jsonPayload.path.includes(maybeSearch)) {
            jsonPayload.path += `?${maybeSearch}`
          }

          return Object.assign(loadObj, {
            status: PageResourceStatus.Success,
            payload: jsonPayload,
          })
        } catch (err) {
          // continue regardless of error
        }
      }

      // Handle 404
      if (status === 404 || status === 200) {
        // If the request was for a 404/500 page and it doesn't exist, we're done
        if (pagePath === `/404.html` || pagePath === `/500.html`) {
          return Object.assign(loadObj, {
            status: PageResourceStatus.Error,
          })
        }

        // Need some code here to cache the 404 request. In case
        // multiple loadPageDataJsons result in 404s
        return this.fetchPageDataJson(
          Object.assign(loadObj, { pagePath: `/404.html`, notFound: true })
        )
      }

      // handle 500 response (Unrecoverable)
      if (status === 500) {
        return this.fetchPageDataJson(
          Object.assign(loadObj, {
            pagePath: `/500.html`,
            internalServerError: true,
          })
        )
      }

      // Handle everything else, including status === 0, and 503s. Should retry
      if (retries < 3) {
        return this.fetchPageDataJson(
          Object.assign(loadObj, { retries: retries + 1 })
        )
      }

      // Retried 3 times already, result is an error.
      return Object.assign(loadObj, {
        status: PageResourceStatus.Error,
      })
    })
  }

  fetchPartialHydrationJson(loadObj) {
    const { pagePath, retries = 0 } = loadObj
    const url = createPageDataUrl(pagePath).replace(`.json`, `-rsc.json`)
    return this.memoizedGet(url).then(req => {
      const { status, responseText } = req

      // Handle 200
      if (status === 200) {
        try {
          return Object.assign(loadObj, {
            status: PageResourceStatus.Success,
            payload: responseText,
          })
        } catch (err) {
          // continue regardless of error
        }
      }

      // Handle 404
      if (status === 404 || status === 200) {
        // If the request was for a 404/500 page and it doesn't exist, we're done
        if (pagePath === `/404.html` || pagePath === `/500.html`) {
          return Object.assign(loadObj, {
            status: PageResourceStatus.Error,
          })
        }

        // Need some code here to cache the 404 request. In case
        // multiple loadPageDataJsons result in 404s
        return this.fetchPartialHydrationJson(
          Object.assign(loadObj, { pagePath: `/404.html`, notFound: true })
        )
      }

      // handle 500 response (Unrecoverable)
      if (status === 500) {
        return this.fetchPartialHydrationJson(
          Object.assign(loadObj, {
            pagePath: `/500.html`,
            internalServerError: true,
          })
        )
      }

      // Handle everything else, including status === 0, and 503s. Should retry
      if (retries < 3) {
        return this.fetchPartialHydrationJson(
          Object.assign(loadObj, { retries: retries + 1 })
        )
      }

      // Retried 3 times already, result is an error.
      return Object.assign(loadObj, {
        status: PageResourceStatus.Error,
      })
    })
  }

  loadPageDataJson(rawPath) {
    const pagePath = findPath(rawPath)
    if (this.pageDataDb.has(pagePath)) {
      const pageData = this.pageDataDb.get(pagePath)
      if (process.env.BUILD_STAGE !== `develop` || !pageData.stale) {
        return Promise.resolve(pageData)
      }
    }

    return this.fetchPageDataJson({ pagePath }).then(pageData => {
      this.pageDataDb.set(pagePath, pageData)

      return pageData
    })
  }

  loadPartialHydrationJson(rawPath) {
    const pagePath = findPath(rawPath)
    if (this.partialHydrationDb.has(pagePath)) {
      const pageData = this.partialHydrationDb.get(pagePath)
      if (process.env.BUILD_STAGE !== `develop` || !pageData.stale) {
        return Promise.resolve(pageData)
      }
    }

    return this.fetchPartialHydrationJson({ pagePath }).then(pageData => {
      this.partialHydrationDb.set(pagePath, pageData)

      return pageData
    })
  }

  loadSliceDataJson(sliceName) {
    if (this.slicesDataDb.has(sliceName)) {
      const jsonPayload = this.slicesDataDb.get(sliceName)
      return Promise.resolve({ sliceName, jsonPayload })
    }

    const url = `${__PATH_PREFIX__}/slice-data/${sliceName}.json`
    return doFetch(url, `GET`).then(res => {
      const jsonPayload = JSON.parse(res.responseText)

      this.slicesDataDb.set(sliceName, jsonPayload)
      return { sliceName, jsonPayload }
    })
  }

  findMatchPath(rawPath) {
    return findMatchPath(rawPath)
  }

  // TODO check all uses of this and whether they use undefined for page resources not exist
  loadPage(rawPath) {
    const pagePath = findPath(rawPath)
    if (this.pageDb.has(pagePath)) {
      const page = this.pageDb.get(pagePath)
      if (process.env.BUILD_STAGE !== `develop` || !page.payload.stale) {
        if (page.error) {
          return Promise.resolve({
            error: page.error,
            status: page.status,
          })
        }

        return Promise.resolve(page.payload)
      }
    }

    if (this.inFlightDb.has(pagePath)) {
      return this.inFlightDb.get(pagePath)
    }

    const loadDataPromises = [
      this.loadAppData(),
      this.loadPageDataJson(pagePath),
    ]

    if (global.hasPartialHydration) {
      loadDataPromises.push(this.loadPartialHydrationJson(pagePath))
    }

    const inFlightPromise = Promise.all(loadDataPromises).then(allData => {
      const [appDataResponse, pageDataResponse, rscDataResponse] = allData

      if (
        pageDataResponse.status === PageResourceStatus.Error ||
        rscDataResponse?.status === PageResourceStatus.Error
      ) {
        return {
          status: PageResourceStatus.Error,
        }
      }

      let pageData = pageDataResponse.payload

      const {
        componentChunkName,
        staticQueryHashes: pageStaticQueryHashes = [],
        slicesMap = {},
      } = pageData

      const finalResult = {}

      const dedupedSliceNames = Array.from(new Set(Object.values(slicesMap)))

      const loadSlice = slice => {
        if (this.slicesDb.has(slice.name)) {
          return this.slicesDb.get(slice.name)
        } else if (this.sliceInflightDb.has(slice.name)) {
          return this.sliceInflightDb.get(slice.name)
        }

        const inFlight = this.loadComponent(slice.componentChunkName).then(
          component => {
            return {
              component: preferDefault(component),
              sliceContext: slice.result.sliceContext,
              data: slice.result.data,
            }
          }
        )

        this.sliceInflightDb.set(slice.name, inFlight)
        inFlight.then(results => {
          this.slicesDb.set(slice.name, results)
          this.sliceInflightDb.delete(slice.name)
        })

        return inFlight
      }

      return Promise.all(
        dedupedSliceNames.map(sliceName => this.loadSliceDataJson(sliceName))
      ).then(slicesData => {
        const slices = []
        const dedupedStaticQueryHashes = [...pageStaticQueryHashes]

        for (const { jsonPayload, sliceName } of Object.values(slicesData)) {
          slices.push({ name: sliceName, ...jsonPayload })
          for (const staticQueryHash of jsonPayload.staticQueryHashes) {
            if (!dedupedStaticQueryHashes.includes(staticQueryHash)) {
              dedupedStaticQueryHashes.push(staticQueryHash)
            }
          }
        }

        const loadChunkPromises = [
          Promise.all(slices.map(loadSlice)),
          this.loadComponent(componentChunkName, `head`),
        ]

        if (!global.hasPartialHydration) {
          loadChunkPromises.push(this.loadComponent(componentChunkName))
        }

        // In develop we have separate chunks for template and Head components
        // to enable HMR (fast refresh requires single exports).
        // In production we have shared chunk with both exports. Double loadComponent here
        // will be deduped by webpack runtime resulting in single request and single module
        // being loaded for both `component` and `head`.
        // get list of components to get
        const componentChunkPromises = Promise.all(loadChunkPromises).then(
          components => {
            const [sliceComponents, headComponent, pageComponent] = components

            finalResult.createdAt = new Date()

            for (const sliceComponent of sliceComponents) {
              if (!sliceComponent || sliceComponent instanceof Error) {
                finalResult.status = PageResourceStatus.Error
                finalResult.error = sliceComponent
              }
            }

            if (
              !global.hasPartialHydration &&
              (!pageComponent || pageComponent instanceof Error)
            ) {
              finalResult.status = PageResourceStatus.Error
              finalResult.error = pageComponent
            }

            let pageResources

            if (finalResult.status !== PageResourceStatus.Error) {
              finalResult.status = PageResourceStatus.Success
              if (
                pageDataResponse.notFound === true ||
                rscDataResponse?.notFound === true
              ) {
                finalResult.notFound = true
              }
              pageData = Object.assign(pageData, {
                webpackCompilationHash: appDataResponse
                  ? appDataResponse.webpackCompilationHash
                  : ``,
              })

              if (typeof rscDataResponse?.payload === `string`) {
                pageResources = toPageResources(pageData, null, headComponent)

                pageResources.partialHydration = rscDataResponse.payload

                const readableStream = new ReadableStream({
                  start(controller) {
                    const te = new TextEncoder()
                    controller.enqueue(te.encode(rscDataResponse.payload))
                  },
                  pull(controller) {
                    // close on next read when queue is empty
                    controller.close()
                  },
                  cancel() {},
                })

                return waitForResponse(
                  createFromReadableStream(readableStream)
                ).then(result => {
                  pageResources.partialHydration = result

                  return pageResources
                })
              } else {
                pageResources = toPageResources(
                  pageData,
                  pageComponent,
                  headComponent
                )
              }
            }

            // undefined if final result is an error
            return pageResources
          }
        )

        // get list of static queries to get
        const staticQueryBatchPromise = Promise.all(
          dedupedStaticQueryHashes.map(staticQueryHash => {
            // Check for cache in case this static query result has already been loaded
            if (this.staticQueryDb[staticQueryHash]) {
              const jsonPayload = this.staticQueryDb[staticQueryHash]
              return { staticQueryHash, jsonPayload }
            }

            return this.memoizedGet(
              `${__PATH_PREFIX__}/page-data/sq/d/${staticQueryHash}.json`
            )
              .then(req => {
                const jsonPayload = JSON.parse(req.responseText)
                return { staticQueryHash, jsonPayload }
              })
              .catch(() => {
                throw new Error(
                  `We couldn't load "${__PATH_PREFIX__}/page-data/sq/d/${staticQueryHash}.json"`
                )
              })
          })
        ).then(staticQueryResults => {
          const staticQueryResultsMap = {}

          staticQueryResults.forEach(({ staticQueryHash, jsonPayload }) => {
            staticQueryResultsMap[staticQueryHash] = jsonPayload
            this.staticQueryDb[staticQueryHash] = jsonPayload
          })

          return staticQueryResultsMap
        })

        return (
          Promise.all([componentChunkPromises, staticQueryBatchPromise])
            .then(([pageResources, staticQueryResults]) => {
              let payload
              if (pageResources) {
                payload = { ...pageResources, staticQueryResults }
                finalResult.payload = payload
                emitter.emit(`onPostLoadPageResources`, {
                  page: payload,
                  pageResources: payload,
                })
              }

              this.pageDb.set(pagePath, finalResult)

              if (finalResult.error) {
                return {
                  error: finalResult.error,
                  status: finalResult.status,
                }
              }

              return payload
            })
            // when static-query fail to load we throw a better error
            .catch(err => {
              return {
                error: err,
                status: PageResourceStatus.Error,
              }
            })
        )
      })
    })

    inFlightPromise
      .then(() => {
        this.inFlightDb.delete(pagePath)
      })
      .catch(error => {
        this.inFlightDb.delete(pagePath)
        throw error
      })

    this.inFlightDb.set(pagePath, inFlightPromise)

    return inFlightPromise
  }

  // returns undefined if the page does not exists in cache
  loadPageSync(rawPath, options = {}) {
    const pagePath = findPath(rawPath)
    if (this.pageDb.has(pagePath)) {
      const pageData = this.pageDb.get(pagePath)

      if (pageData.payload) {
        return pageData.payload
      }

      if (options?.withErrorDetails) {
        return {
          error: pageData.error,
          status: pageData.status,
        }
      }
    }
    return undefined
  }

  shouldPrefetch(pagePath) {
    // Skip prefetching if we know user is on slow or constrained connection
    if (!doesConnectionSupportPrefetch()) {
      return false
    }

    // Don't prefetch if this is a crawler bot
    if (navigator.userAgent && BOT_REGEX.test(navigator.userAgent)) {
      return false
    }

    // Check if the page exists.
    if (this.pageDb.has(pagePath)) {
      return false
    }

    return true
  }

  prefetch(pagePath) {
    if (!this.shouldPrefetch(pagePath)) {
      return {
        then: resolve => resolve(false),
        abort: () => {},
      }
    }
    if (this.prefetchTriggered.has(pagePath)) {
      return {
        then: resolve => resolve(true),
        abort: () => {},
      }
    }

    const defer = {
      resolve: null,
      reject: null,
      promise: null,
    }
    defer.promise = new Promise((resolve, reject) => {
      defer.resolve = resolve
      defer.reject = reject
    })
    this.prefetchQueued.push([pagePath, defer])
    const abortC = new AbortController()
    abortC.signal.addEventListener(`abort`, () => {
      const index = this.prefetchQueued.findIndex(([p]) => p === pagePath)
      // remove from the queue
      if (index !== -1) {
        this.prefetchQueued.splice(index, 1)
      }
    })

    if (!this.isPrefetchQueueRunning) {
      this.isPrefetchQueueRunning = true
      setTimeout(() => {
        this._processNextPrefetchBatch()
      }, 3000)
    }

    return {
      then: (resolve, reject) => defer.promise.then(resolve, reject),
      abort: abortC.abort.bind(abortC),
    }
  }

  _processNextPrefetchBatch() {
    const idleCallback = window.requestIdleCallback || (cb => setTimeout(cb, 0))

    idleCallback(() => {
      const toPrefetch = this.prefetchQueued.splice(0, 4)
      const prefetches = Promise.all(
        toPrefetch.map(([pagePath, dPromise]) => {
          // Tell plugins with custom prefetching logic that they should start
          // prefetching this path.
          if (!this.prefetchTriggered.has(pagePath)) {
            this.apiRunner(`onPrefetchPathname`, { pathname: pagePath })
            this.prefetchTriggered.add(pagePath)
          }

          // If a plugin has disabled core prefetching, stop now.
          if (this.prefetchDisabled) {
            return dPromise.resolve(false)
          }

          return this.doPrefetch(findPath(pagePath)).then(() => {
            if (!this.prefetchCompleted.has(pagePath)) {
              this.apiRunner(`onPostPrefetchPathname`, { pathname: pagePath })
              this.prefetchCompleted.add(pagePath)
            }

            dPromise.resolve(true)
          })
        })
      )

      if (this.prefetchQueued.length) {
        prefetches.then(() => {
          setTimeout(() => {
            this._processNextPrefetchBatch()
          }, 3000)
        })
      } else {
        this.isPrefetchQueueRunning = false
      }
    })
  }

  doPrefetch(pagePath) {
    const pageDataUrl = createPageDataUrl(pagePath)

    if (global.hasPartialHydration) {
      return Promise.all([
        prefetchHelper(pageDataUrl, {
          crossOrigin: `anonymous`,
          as: `fetch`,
        }).then(() =>
          // This was just prefetched, so will return a response from
          // the cache instead of making another request to the server
          this.loadPageDataJson(pagePath)
        ),
        prefetchHelper(pageDataUrl.replace(`.json`, `-rsc.json`), {
          crossOrigin: `anonymous`,
          as: `fetch`,
        }).then(() =>
          // This was just prefetched, so will return a response from
          // the cache instead of making another request to the server
          this.loadPartialHydrationJson(pagePath)
        ),
      ])
    } else {
      return prefetchHelper(pageDataUrl, {
        crossOrigin: `anonymous`,
        as: `fetch`,
      }).then(() =>
        // This was just prefetched, so will return a response from
        // the cache instead of making another request to the server
        this.loadPageDataJson(pagePath)
      )
    }
  }

  hovering(rawPath) {
    this.loadPage(rawPath)
  }

  getResourceURLsForPathname(rawPath) {
    const pagePath = findPath(rawPath)
    const page = this.pageDataDb.get(pagePath)
    if (page) {
      const pageResources = toPageResources(page.payload)

      return [
        ...createComponentUrls(pageResources.page.componentChunkName),
        createPageDataUrl(pagePath),
      ]
    } else {
      return null
    }
  }

  isPageNotFound(rawPath) {
    const pagePath = findPath(rawPath)
    const page = this.pageDb.get(pagePath)
    return !page || page.notFound
  }

  loadAppData(retries = 0) {
    return this.memoizedGet(`${__PATH_PREFIX__}/page-data/app-data.json`).then(
      req => {
        const { status, responseText } = req

        let appData

        if (status !== 200 && retries < 3) {
          // Retry 3 times incase of non-200 responses
          return this.loadAppData(retries + 1)
        }

        // Handle 200
        if (status === 200) {
          try {
            const jsonPayload = JSON.parse(responseText)
            if (jsonPayload.webpackCompilationHash === undefined) {
              throw new Error(`not a valid app-data response`)
            }

            appData = jsonPayload
          } catch (err) {
            // continue regardless of error
          }
        }

        return appData
      }
    )
  }
}

const createComponentUrls = componentChunkName =>
  (window.___chunkMapping[componentChunkName] || []).map(
    chunk => __PATH_PREFIX__ + chunk
  )

export class ProdLoader extends BaseLoader {
  constructor(asyncRequires, matchPaths, pageData) {
    const loadComponent = (chunkName, exportType = `components`) => {
      if (!global.hasPartialHydration) {
        exportType = `components`
      }

      if (!asyncRequires[exportType][chunkName]) {
        throw new Error(
          `We couldn't find the correct component chunk with the name "${chunkName}"`
        )
      }

      return (
        asyncRequires[exportType][chunkName]()
          // loader will handle the case when component is error
          .catch(err => err)
      )
    }

    super(loadComponent, matchPaths)

    if (pageData) {
      this.pageDataDb.set(findPath(pageData.path), {
        pagePath: pageData.path,
        payload: pageData,
        status: `success`,
      })
    }
  }

  doPrefetch(pagePath) {
    return super.doPrefetch(pagePath).then(result => {
      if (result.status !== PageResourceStatus.Success) {
        return Promise.resolve()
      }
      const pageData = result.payload
      const chunkName = pageData.componentChunkName
      const componentUrls = createComponentUrls(chunkName)
      return Promise.all(componentUrls.map(prefetchHelper)).then(() => pageData)
    })
  }

  loadPageDataJson(rawPath) {
    return super.loadPageDataJson(rawPath).then(data => {
      if (data.notFound) {
        if (shouldAbortFetch(rawPath)) {
          return data
        }
        // check if html file exist using HEAD request:
        // if it does we should navigate to it instead of showing 404
        return doFetch(rawPath, `HEAD`).then(req => {
          if (req.status === 200) {
            // page (.html file) actually exist (or we asked for 404 )
            // returning page resources status as errored to trigger
            // regular browser navigation to given page
            return {
              status: PageResourceStatus.Error,
            }
          }

          // if HEAD request wasn't 200, return notFound result
          // and show 404 page
          return data
        })
      }
      return data
    })
  }

  loadPartialHydrationJson(rawPath) {
    return super.loadPartialHydrationJson(rawPath).then(data => {
      if (data.notFound) {
        if (shouldAbortFetch(rawPath)) {
          return data
        }
        // check if html file exist using HEAD request:
        // if it does we should navigate to it instead of showing 404
        return doFetch(rawPath, `HEAD`).then(req => {
          if (req.status === 200) {
            // page (.html file) actually exist (or we asked for 404 )
            // returning page resources status as errored to trigger
            // regular browser navigation to given page
            return {
              status: PageResourceStatus.Error,
            }
          }

          // if HEAD request wasn't 200, return notFound result
          // and show 404 page
          return data
        })
      }
      return data
    })
  }
}

let instance

export const setLoader = _loader => {
  instance = _loader
}

export const publicLoader = {
  enqueue: rawPath => instance.prefetch(rawPath),

  // Real methods
  getResourceURLsForPathname: rawPath =>
    instance.getResourceURLsForPathname(rawPath),
  loadPage: rawPath => instance.loadPage(rawPath),
  // TODO add deprecation to v4 so people use withErrorDetails and then we can remove in v5 and change default behaviour
  loadPageSync: (rawPath, options = {}) =>
    instance.loadPageSync(rawPath, options),
  prefetch: rawPath => instance.prefetch(rawPath),
  isPageNotFound: rawPath => instance.isPageNotFound(rawPath),
  hovering: rawPath => instance.hovering(rawPath),
  loadAppData: () => instance.loadAppData(),
}

export default publicLoader

export function getStaticQueryResults() {
  if (instance) {
    return instance.staticQueryDb
  } else {
    return {}
  }
}

export function getSliceResults() {
  if (instance) {
    return instance.slicesDb
  } else {
    return {}
  }
}
